import { Text, ToggleGroup } from '@betterment/samba-react';
import { useField } from 'formik';

type Props = { name: string; disabled: boolean; onTypeChange: (nextType: 'amount' | 'percent') => void };

export const DeferralTypeToggle = ({ name, disabled, onTypeChange }: Props) => {
  const [field] = useField(name);

  return (
    <ToggleGroup
      type="single"
      spacing="default"
      disabled={disabled}
      onValueChange={onTypeChange}
      data-testid={`deferral-toggle-${name.replaceAll('.', '-')}`}
      {...field}
    >
      <ToggleGroup.Item value="percent" disabled={field.value === 'percent'}>
        <Text css={{ px: 'space.100' }}>%</Text>
      </ToggleGroup.Item>
      <ToggleGroup.Item value="amount" disabled={field.value === 'amount'}>
        <Text css={{ px: 'space.100' }}>$</Text>
      </ToggleGroup.Item>
    </ToggleGroup>
  );
};
